import { parseAssetData } from 'api/parsers/parseAssetData';
import { fetch } from 'api/typedFetch';

export const getData = async (id: string, type: string) => {
  const response = await fetch('GET_ASSETS', {
    params: new URLSearchParams({ app_id: id, type, format: 'json' }),
  });

  const data = await response.json();

  return data.map(parseAssetData).filter((item) => {
    if (item.type === 'internal') {
      return false;
    }

    // TODO: Shaky fix, titles are unstable user-facing data. @ChrisTravPRO Boolean from API? (7350379681)
    return !item?.title?.toLowerCase().startsWith('hide');
  });
};
